import Config from "../../../Configs";
import { ApiResponse, LoginRequest, RegisterRequest, UserDetails } from "../../../Models";
import { IHttpService } from "../IHttpService";
import { ApiServiceBase } from "./ApiServiceBase";

export default class AuthApiService extends ApiServiceBase {
    constructor(client: IHttpService) {
        super(client);
    }

    async register(data: RegisterRequest): Promise<ApiResponse<string>> {
        return await this._client.post<string>(Config.apiPaths.register, data);
    }

    async login(data: LoginRequest): Promise<ApiResponse<UserDetails>> {
        return await this._client.post<UserDetails>(Config.apiPaths.login, data);
    }

    async logout(): Promise<ApiResponse<any>> {
        return await this._client.post<any>(Config.apiPaths.logout);
    }

    async confirmEmail(userId: string, token: string): Promise<ApiResponse<string>> {
        return await this._client.get(`${Config.apiPaths.confirmEmail}?userId=${userId}&code=${token}`);
    }

    async resendEmail(email: string): Promise<ApiResponse<string>> {
        return await this._client.get(`${Config.apiPaths.resendEmail}?username=${email}`);
    }

    async forgotPassword(email: string): Promise<ApiResponse<string>> {
        return await this._client.get(`${Config.apiPaths.forgotPassword}?username=${email}`);
    }

    async validateResetPasswordToken(email: string, token: string): Promise<ApiResponse<string>> {
        return await this._client.get(`${Config.apiPaths.validatePasswordResetToken}?username=${email}&token=${token}`);
    }

    async updatePassword(username: string, token: string, password: string): Promise<ApiResponse<string>> {
        return await this._client.post(`${Config.apiPaths.updatePassword}`, {
            username,
            token,
            password,
        });
    }
}
